<main class="bg-black text-white min-h-screen overflow-x-hidden solutions-landing">
  <section class="relative pt-28 pb-16 md:pt-32 md:pb-20 overflow-hidden">
    <div class="animated-grid-shift"></div>
    <div class="pulse-ring"></div>
    <div class="hero-particles" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="blob blob-one"></div>
    <div class="blob blob-two"></div>
    <div class="absolute inset-0 opacity-[0.03]"
      style="background-image: linear-gradient(rgba(0,170,230,0.55) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.55) 1px, transparent 1px); background-size: 56px 56px;">
    </div>

    <div class="relative z-10 max-w-7xl mx-auto px-6">
      <a routerLink="/" class="back-nav mb-6 inline-flex" data-aos="fade-down">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
        Back
      </a>
      <p class="text-varroc-accent uppercase tracking-[0.35em] text-xs font-bold mb-4" data-aos="fade-up">Solution Hub
      </p>
      <h1 class="text-3xl md:text-5xl lg:text-6xl font-black leading-tight max-w-none mb-5" data-aos="fade-up"
        data-aos-delay="100">
        <span class="block text-white md:whitespace-nowrap">A Unified Platform for Enterprise Mobility,</span>
        <span class="block text-varroc-accent md:whitespace-nowrap">Consumer Experiences & Connected Things</span>
      </h1>
      <p class="text-varroc-text-gray text-base md:text-lg max-w-3xl" data-aos="fade-up" data-aos-delay="180">
        Explore every solution experience in one place. Start with business transformation, then dive into connected
        consumer journeys.
      </p>
    </div>
  </section>

  <!-- <section class="max-w-7xl mx-auto px-6 pb-12">
    <div class="section-panel" data-aos="fade-up">
      <div class="flex flex-wrap items-end justify-between gap-4 mb-7">
        <div>
          <h2 class="text-3xl md:text-4xl font-black">Business</h2>
        </div>
        <a routerLink="/solutions/business" class="inline-flex items-center gap-2 text-sm font-bold border border-varroc-accent/40 px-4 py-2 rounded-md hover:bg-varroc-accent hover:text-white transition-all">
          Explore Business Overview <i class='bx bx-right-arrow-alt text-lg'></i>
        </a>
      </div>

      <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <a *ngFor="let item of businessSolutions; let i = index"
           [routerLink]="item.route"
           class="nav-card"
           [attr.data-aos]="'fade-up'"
           [attr.data-aos-delay]="(120 + i * 70).toString()">
          <div class="w-11 h-11 rounded-xl bg-varroc-accent/15 border border-varroc-accent/20 flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-2xl' [class]="item.icon"></i>
          </div>
          <div class="text-white font-bold text-lg mb-1">{{ item.title }}</div>
          <div class="text-varroc-text-gray text-sm mb-6">{{ item.subtitle }}</div>
          <div class="inline-flex items-center gap-1 text-varroc-accent text-sm font-semibold">
            Open <i class='bx bx-right-arrow-alt text-lg'></i>
          </div>
        </a>
      </div>
    </div>
  </section> -->

  <!-- <section class="max-w-7xl mx-auto px-6 pb-20 md:pb-28">
    <div class="section-panel" data-aos="fade-up" data-aos-delay="80">
      <div class="flex flex-wrap items-end justify-between gap-4 mb-7">
        <div>
          <h2 class="text-3xl md:text-4xl font-black">Consumers</h2>
        </div>
        <a routerLink="/solutions/consumers" class="inline-flex items-center gap-2 text-sm font-bold border border-varroc-accent/40 px-4 py-2 rounded-md hover:bg-varroc-accent hover:text-white transition-all">
          Explore Consumer Overview <i class='bx bx-right-arrow-alt text-lg'></i>
        </a>
      </div>

      <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <a *ngFor="let item of consumerSolutions; let i = index"
           [routerLink]="item.route"
           class="nav-card"
           [attr.data-aos]="'fade-up'"
           [attr.data-aos-delay]="(140 + i * 70).toString()">
          <div class="w-11 h-11 rounded-xl bg-varroc-accent/15 border border-varroc-accent/20 flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-2xl' [class]="item.icon"></i>
          </div>
          <div class="text-white font-bold text-lg mb-1">{{ item.title }}</div>
          <div class="text-varroc-text-gray text-sm mb-6">{{ item.subtitle }}</div>
          <div class="inline-flex items-center gap-1 text-varroc-accent text-sm font-semibold">
            Open <i class='bx bx-right-arrow-alt text-lg'></i>
          </div>
        </a>
      </div>
    </div>
  </section> -->

  <section class="max-w-7xl mx-auto px-6 pb-24 md:pb-28">
    <div class="section-panel" data-aos="fade-up">
      <div class="flex flex-wrap items-end justify-between gap-4 mb-7">
        <div>
          <h2 class="text-3xl md:text-4xl font-black mb-3">Built to transform how vehicles, users, and systems interact
          </h2>
          <p class="text-varroc-text-gray text-sm md:text-base leading-relaxed max-w-4xl">
            At the core of our offerings is a powerful connected intelligence ecosystem that brings together telematics,
            cloud infrastructure, a unified SDK, and scalable applications.
          </p>
        </div>
        <div
          class="inline-flex items-center gap-2 text-sm font-bold border border-varroc-accent/30 px-4 py-2 rounded-md text-varroc-accent/90 bg-varroc-accent/5">
          Connected Intelligence Ecosystem
        </div>
      </div>

      <div class="space-y-10">
        <div class="track-block" data-aos="fade-up" data-aos-delay="120">
          <div class="track-intro mb-6">
            <p class="text-varroc-accent uppercase tracking-[0.24em] text-[11px] font-bold mb-2">Business Track</p>
            <h3 class="text-xl md:text-2xl font-black text-white mb-2">For Business</h3>
            <p class="text-varroc-text-gray text-sm leading-relaxed max-w-xl">
              Flexible connected infrastructure for OEMs, fleets, insurers, and enterprise operations.
            </p>
          </div>

          <div class="grid lg:grid-cols-2 gap-4">
            <a *ngFor="let item of businessSolutions" [routerLink]="item.route" class="nav-card nav-card--elongated">
              <div
                class="w-11 h-11 shrink-0 rounded-xl bg-varroc-accent/15 border border-varroc-accent/20 flex items-center justify-center">
                <i class='bx icon-gradient text-2xl' [class]="item.icon"></i>
              </div>
              <div class="flex-1 min-w-0">
                <div class="text-white font-bold text-lg mb-1">{{ item.title }}</div>
                <div class="text-varroc-text-gray text-[13px] md:text-sm leading-relaxed">{{ item.subtitle }}</div>
              </div>
              <div class="inline-flex items-center gap-1 text-varroc-accent text-sm font-semibold shrink-0">
                Open <i class='bx bx-right-arrow-alt text-lg'></i>
              </div>
            </a>
          </div>
        </div>

        <div class="track-block" data-aos="fade-up" data-aos-delay="180">
          <div class="track-intro mb-6">
            <p class="text-varroc-accent uppercase tracking-[0.24em] text-[11px] font-bold mb-2">Consumer Track</p>
            <h3 class="text-xl md:text-2xl font-black text-white mb-2">For Consumers</h3>
            <p class="text-varroc-text-gray text-sm leading-relaxed max-w-xl">
              Safety, convenience, and rewards experiences designed around connected users.
            </p>
          </div>

          <div class="grid lg:grid-cols-2 gap-4">
            <a *ngFor="let item of consumerSolutions" [routerLink]="item.route" class="nav-card nav-card--elongated">
              <div
                class="w-11 h-11 shrink-0 rounded-xl bg-varroc-accent/15 border border-varroc-accent/20 flex items-center justify-center">
                <i class='bx icon-gradient text-2xl' [class]="item.icon"></i>
              </div>
              <div class="flex-1 min-w-0">
                <div class="text-white font-bold text-lg mb-1">{{ item.title }}</div>
                <div class="text-varroc-text-gray text-[13px] md:text-sm leading-relaxed">{{ item.subtitle }}</div>
              </div>
              <div class="inline-flex items-center gap-1 text-varroc-accent text-sm font-semibold shrink-0">
                Open <i class='bx bx-right-arrow-alt text-lg'></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>